<template>
	<div>
		<div class="login_bg">
			<div class="login_con">
				<div>
					<el-form :model="registForm" ref="registForms" :rules="rules">
						<h2 class="reset_h2">重置密码</h2>
						<el-form-item class="go_login" v-if="registerStatus">
							<i class="el-icon-warning"></i>
							账号未注册，你可以去去<router-link to="/register">注册</router-link>
						</el-form-item>
						<el-form-item prop="phone">
							<el-input placeholder="手机号" maxlength="11" v-model.trim="registForm.phone"></el-input>
						</el-form-item>
						<el-form-item>
							<loadsolid v-model="isLock" @change="handlerLock"></loadsolid>
						</el-form-item>
						<el-form-item prop="code">
							<div class="code_box">
								<el-input type="text" maxlength="6" placeholder="验证码" v-model.trim="registForm.code"
									autocomplete="off">
								</el-input>
								<el-button :disabled="codeDis||registForm.phone.length!==11" type="" class="code_btn"
									@click="getPhone" v-if="codeStatus">
									获取验证码</el-button>
								<el-button class="code_btn" v-else disabled>重发{{ codeTime }}s
								</el-button>
							</div>
						</el-form-item>
						<el-form-item prop="password" class="m_bottom_0">
							<el-input show-password type="password" placeholder="8-20位密码"
								v-model.trim="registForm.password" autocomplete="off">
							</el-input>
						</el-form-item>
						<div class="reg_box">
							已有账号！<router-link to="/login">去登录</router-link>
						</div>
						<el-form-item class="m_bottom_0">
							<el-button type="primary" :disabled="codeDis ||registForm.password==''||registForm.code==''"
								class="registerbtn" @click="submitForm">确定
							</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
		<FooterCopy></FooterCopy>
	</div>
</template>

<script>
	import loadsolid from '../../components/LoginSolid.vue'
	import FooterCopy from '../../components/FooterCopy.vue'
	export default {
		name: 'forgot',
		components: {
			loadsolid,
			FooterCopy
		},
		data() {
			var validpassword = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else if (value.length < 8) {
					callback(new Error('密码不能少于8位'));
				} else if (value.length > 20) {
					callback(new Error('密码不能超过20位'));
				} else {
					callback();
				}
			};
			var validCode = (rule, value, callback) => {
				if (value.length < 6) {
					callback(new Error('验证码不能少于6位'));
				} else {
					callback();
				}
			};

			var validphone = (rule, value, callback) => {
				const mailReg = /^1[3-9]\d{9}$/;
				if (!value) {
					callback(new Error('请输入手机号'));
				} else {
					if (mailReg.test(value)) {
						callback();
					} else {
						callback(new Error('手机号错误'));
					}
				}
			};
			return {
				isLock: false,
				//是否登录
				registerStatic: false,
				//用户名
				userName: '',
				//去输入用户名
				registerFirst: true,
				//用户名跳过dialog
				dialogVisible: false,
				//滑动状态
				codeDis: true,
				//获取验证码状态
				codeStatus: true,
				//验证码时间
				codeTime: 60,
				registForm: {
					name: '',
					phone: '',
					password: '',
					code: '',
				},
				rules: {
					password: [{
						validator: validpassword,
						trigger: 'blur',
						required: true,
					}],

					code: [{
						validator: validCode,
						trigger: 'blur',
						required: true,
					}],
					phone: [{
						validator: validphone,
						trigger: 'blur',
						required: true,
					}]
				},
				//是否去登录
				registerStatus: false,
				//倒计时
				timer: null
			};
		},
		methods: {

			getCode() {
				this.$axios.post('/front/login/sendSmsCode', {
					'login': this.registForm.phone
				}).then((res) => {
					if (res.code == 200) this.$msg.success('验证码已发送')
					// this.registForm.code = res.data
				})
			},


			//获取验证码
			getPhone() {
				this.codeStatus = false;
				this.timer = setInterval(() => {
					if (this.codeTime > 1 && this.codeTime <= 60) {
						this.codeTime--;
					} else {
						this.codeTime = 3;
						this.codeStatus = true;
						clearInterval(this.timer);
						this.timer = null;
					}
				}, 1000);
				this.getCode()
			},
			//滑动监听
			handlerLock(data) {
				if (data) {
					this.isLock = true;
					this.codeDis = false
				}
			},

			//提交表单
			submitForm() {
				this.$refs['registForms'].validate((valid) => {
					if (valid) {
						this.$axios.post('/front/login/password', {
							code: this.registForm.code,
							newPassword: this.registForm.password,
							phone: this.registForm.phone,
						}).then(res => {
							if (res.code == 200) {
								this.$msg.success('密码重置成功，去登录');
								setTimeout(() => {
									this.$router.push({
										name: 'login'
									})
								}, 2000)
								return
							}
							if (res.code == 401) {
								this.$msg.error('请刷新重试')
								return
							}
							if (res.code == 403) {
								this.$msg.error('手机号未注册，请去注册')
								return
							}
							if (res.code == 404) {
								this.$msg.error('密码错误')
								return
							}
							if (res.code == 405) {
								this.$msg.error('用户被停用')
								return
							}
						})
					} else {
						// console.log('error submit!!');
						return false;
					}
				});
				// console.log(this.registForm);
			},
		}
	};
</script>

<style lang="scss" scoped>
	.reg_box {
		text-align: right;
		line-height: 34px;
		padding: 4px 0 14px 0;
		color: var(--info);

		a {
			color: var(--brand);
		}

	}

	.m_bottom_0 {
		margin-bottom: 0;
	}

	.reset_h2 {
		margin-bottom: 20px;
	}

	.login_bg {
		position: fixed;
		// background: url("../../assets/image/login/login-tommyp.jpg") no-repeat;
		background-size: cover;
		width: 100%;
		height: 100%;

		.login_con {
			width: 340px;
			margin: 12% auto 0 auto;
			border-radius: 10px;
			padding: 30px;
			background-color: white;
		}
	}

	.code_box {
		display: flex;
	}

	.code_btn {
		width: 140px;
		margin-left: 20px;
	}

	.go_login {
		border-radius: 3px;
		padding-left: 14px;
		background-color: #ffe0e0;
		color: var(--info);

		a {
			color: var(--brand);
			display: inline-block;
			margin-left: 2px;
		}
	}

	.registerbtn {
		width: 100%;
	}

	.username {
		color: var(--brand);
	}

	.registerSuccess {
		margin-top: 20vh;
		text-align: center;

		i {
			margin-bottom: 10px;
			color: var(--brand);
			font-size: 120px;
		}

	}
</style>
